import dayjs from 'dayjs'
import 'dayjs/locale/es'
import 'dayjs/locale/ca'
import 'dayjs/locale/eu'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

dayjs.locale('es')

export default {
  getDay (date) {
    return dayjs(date).format('DD')
  },
  getMonth (date) {
    return dayjs(date).format('MMMM')
  },
  changeLocale (locale) {
    dayjs.locale(locale)
  },
  getFromDate (date, locale) {
    dayjs.locale(locale)
    const from = dayjs(date).from(new Date())
    const dateToReturn = from.charAt(0).toUpperCase() + from.slice(1)
    return dateToReturn
  },
  getStartDate (date) {
    return dayjs(date).format('DD/MM/YYYY')
  },
  getNewDate (date) {
    return dayjs(date)
  }
}
